// Development configuration
export const DEV_CONFIG = {
  // Set to true to use mock data instead of OpenAI API calls
  USE_MOCK_DATA: import.meta.env.VITE_USE_MOCK_DATA === 'true' || false,

  // Set to true to enable detailed logging for debugging
  ENABLE_DEBUG_LOGGING: import.meta.env.VITE_ENABLE_DEBUG_LOGGING === 'true' || false,

  // Mock response delay (in ms) to simulate API latency
  MOCK_RESPONSE_DELAY: 1500,
};

// Helper function to check if we're in development mode
export const isDevelopment = () => import.meta.env.DEV;

// Helper function to check if mock data should be used
export const shouldUseMockData = () => isDevelopment() && DEV_CONFIG.USE_MOCK_DATA;
